var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      style: _vm.modalStyle,
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        maskClosable: false,
        forceRender: true,
        fullscreen: "",
        switchFullscreen: "",
        wrapClassName: "ant-modal-cust-warp",
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c(
        "template",
        { slot: "footer" },
        [
          _c("a-button", { key: "back", on: { click: _vm.handleCancel } }, [
            _vm._v("取消(ESC)"),
          ]),
          _vm.financialType === "收预付款"
            ? _c(
                "a-button",
                {
                  directives: [
                    {
                      name: "print",
                      rawName: "v-print",
                      value: "#advanceInPrint",
                      expression: "'#advanceInPrint'",
                    },
                  ],
                },
                [_vm._v("打印")]
              )
            : _vm._e(),
          _vm.financialType === "转账"
            ? _c(
                "a-button",
                {
                  directives: [
                    {
                      name: "print",
                      rawName: "v-print",
                      value: "#giroPrint",
                      expression: "'#giroPrint'",
                    },
                  ],
                },
                [_vm._v("打印")]
              )
            : _vm._e(),
          _vm.financialType === "收入"
            ? _c(
                "a-button",
                {
                  directives: [
                    {
                      name: "print",
                      rawName: "v-print",
                      value: "#itemInPrint",
                      expression: "'#itemInPrint'",
                    },
                  ],
                },
                [_vm._v("打印")]
              )
            : _vm._e(),
          _vm.financialType === "支出"
            ? _c(
                "a-button",
                {
                  directives: [
                    {
                      name: "print",
                      rawName: "v-print",
                      value: "#itemOutPrint",
                      expression: "'#itemOutPrint'",
                    },
                  ],
                },
                [_vm._v("打印")]
              )
            : _vm._e(),
          _vm.financialType === "收款"
            ? _c(
                "a-button",
                {
                  directives: [
                    {
                      name: "print",
                      rawName: "v-print",
                      value: "#moneyInPrint",
                      expression: "'#moneyInPrint'",
                    },
                  ],
                },
                [_vm._v("打印")]
              )
            : _vm._e(),
          _vm.financialType === "付款"
            ? _c(
                "a-button",
                {
                  directives: [
                    {
                      name: "print",
                      rawName: "v-print",
                      value: "#moneyOutPrint",
                      expression: "'#moneyOutPrint'",
                    },
                  ],
                },
                [_vm._v("打印")]
              )
            : _vm._e(),
          _vm.checkFlag && _vm.isCanBackCheck && _vm.model.status === "1"
            ? _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleBackCheck()
                    },
                  },
                },
                [_vm._v("反审核")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-form",
        { attrs: { form: _vm.form } },
        [
          _vm.financialType === "收预付款"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "advanceInPrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "付款会员",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: ["id"],
                                      expression: "['id']",
                                    },
                                  ],
                                  attrs: { hidden: "" },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.organName) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "财务人员",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.handsPersonName) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.billTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.billNo) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("a-table", {
                      ref: "table",
                      attrs: {
                        size: "middle",
                        bordered: "",
                        rowKey: "id",
                        pagination: false,
                        loading: _vm.loading,
                        columns: _vm.advanceInColumns,
                        dataSource: _vm.dataSource,
                      },
                    }),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "合计金额",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.totalPrice) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "收款金额",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.changeAmount) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("a-col", { attrs: { span: 6 } }),
                        _c("a-col", { attrs: { span: 6 } }),
                        _c("a-col", { attrs: { span: 6 } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.financialType === "转账"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "giroPrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "财务人员",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: ["id"],
                                      expression: "['id']",
                                    },
                                  ],
                                  attrs: { hidden: "" },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.handsPersonName) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.billTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.billNo) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("a-col", { attrs: { span: 6 } }),
                      ],
                      1
                    ),
                    _c("a-table", {
                      ref: "table",
                      attrs: {
                        size: "middle",
                        bordered: "",
                        rowKey: "id",
                        pagination: false,
                        loading: _vm.loading,
                        columns: _vm.giroColumns,
                        dataSource: _vm.dataSource,
                      },
                    }),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "付款账户",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.accountName) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "实付金额",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.changeAmount) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("a-col", { attrs: { span: 6 } }),
                        _c("a-col", { attrs: { span: 6 } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.financialType === "收入"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "itemInPrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "往来单位",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: ["id"],
                                      expression: "['id']",
                                    },
                                  ],
                                  attrs: { hidden: "" },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.organName) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "财务人员",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.handsPersonName) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.billTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.billNo) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("a-table", {
                      ref: "table",
                      attrs: {
                        size: "middle",
                        bordered: "",
                        rowKey: "id",
                        pagination: false,
                        loading: _vm.loading,
                        columns: _vm.itemInColumns,
                        dataSource: _vm.dataSource,
                      },
                    }),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "收入账户",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.accountName) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "收入金额",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.changeAmount) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("a-col", { attrs: { span: 6 } }),
                        _c("a-col", { attrs: { span: 6 } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.financialType === "支出"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "itemOutPrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "往来单位",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: ["id"],
                                      expression: "['id']",
                                    },
                                  ],
                                  attrs: { hidden: "" },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.organName) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "财务人员",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.handsPersonName) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.billTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.billNo) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("a-table", {
                      ref: "table",
                      attrs: {
                        size: "middle",
                        bordered: "",
                        rowKey: "id",
                        pagination: false,
                        loading: _vm.loading,
                        columns: _vm.itemOutColumns,
                        dataSource: _vm.dataSource,
                      },
                    }),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "支出账户",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.accountName) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "支出金额",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.changeAmount) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("a-col", { attrs: { span: 6 } }),
                        _c("a-col", { attrs: { span: 6 } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.financialType === "收款"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "moneyInPrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "客户",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: ["id"],
                                      expression: "['id']",
                                    },
                                  ],
                                  attrs: { hidden: "" },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.organName) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "财务人员",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.handsPersonName) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.billTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.billNo) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("a-table", {
                      ref: "table",
                      attrs: {
                        size: "middle",
                        bordered: "",
                        rowKey: "id",
                        pagination: false,
                        loading: _vm.loading,
                        columns: _vm.moneyInColumns,
                        dataSource: _vm.dataSource,
                      },
                    }),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "收款账户",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.accountName) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "合计收款",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.totalPrice) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "优惠金额",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.discountMoney) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "实际收款",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.changeAmount) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.financialType === "付款"
            ? [
                _c(
                  "section",
                  { ref: "print", attrs: { id: "moneyOutPrint" } },
                  [
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "供应商",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: ["id"],
                                      expression: "['id']",
                                    },
                                  ],
                                  attrs: { hidden: "" },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.organName) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "财务人员",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.handsPersonName) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据日期",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.billTimeStr) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "单据编号",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.billNo) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("a-table", {
                      ref: "table",
                      attrs: {
                        size: "middle",
                        bordered: "",
                        rowKey: "id",
                        pagination: false,
                        loading: _vm.loading,
                        columns: _vm.moneyOutColumns,
                        dataSource: _vm.dataSource,
                      },
                    }),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                staticStyle: { padding: "20px 10px" },
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: {
                                    xs: { span: 24 },
                                    sm: { span: 24 },
                                  },
                                  label: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.remark) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "付款账户",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.accountName) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "合计付款",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.totalPrice) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "优惠金额",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.discountMoney) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "实际付款",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.model.changeAmount) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.fileList && _vm.fileList.length > 0
            ? [
                _c(
                  "a-row",
                  { staticClass: "form-row", attrs: { gutter: 24 } },
                  [
                    _c(
                      "a-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "a-form-item",
                          {
                            attrs: {
                              labelCol: { xs: { span: 24 }, sm: { span: 3 } },
                              wrapperCol: {
                                xs: { span: 24 },
                                sm: { span: 21 },
                              },
                              label: "附件",
                            },
                          },
                          [
                            _c("j-upload", {
                              attrs: {
                                bizPath: "bill",
                                disabled: true,
                                buttonVisible: false,
                              },
                              model: {
                                value: _vm.fileList,
                                callback: function ($$v) {
                                  _vm.fileList = $$v
                                },
                                expression: "fileList",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("a-col", { attrs: { span: 12 } }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }